'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'atom-simple';
var width = 512;
var height = 512;
var aliases = ["atom-alt"];
var unicode = 'f5d3';
var svgPathData = 'M180.1 453.3c19.3-6.4 39.8-15.7 60.6-27.7c-28.7-18.8-57.5-42.1-84.9-69.5s-50.7-56.2-69.5-84.9c-11.9 20.8-21.2 41.2-27.7 60.6C41.2 384.4 45.9 423.9 67 445s60.5 25.8 113.1 8.3zM256 416.4c29.8-18.8 60.1-42.8 88.8-71.6s52.8-59 71.6-88.8c-18.8-29.8-42.8-60.1-71.6-88.8s-59-52.8-88.8-71.6c-29.8 18.8-60.1 42.8-88.8 71.6s-52.8 59-71.6 88.8c18.8 29.8 42.8 60.1 71.6 88.8s59 52.8 88.8 71.6zm0 18.8c-82.1 49.2-161.1 60.3-200.3 21.1S27.6 338.1 76.8 256C27.6 173.9 16.5 94.9 55.7 55.7S173.9 27.6 256 76.8c82.1-49.2 161.1-60.3 200.3-21.1s28.1 118.2-21.1 200.3c49.2 82.1 60.3 161.1 21.1 200.3s-118.2 28.1-200.3-21.1zM425.6 271.3c-18.8 28.7-42.1 57.5-69.5 84.9s-56.2 50.7-84.9 69.5c20.8 11.9 41.2 21.2 60.6 27.7c52.6 17.5 92.1 12.8 113.1-8.3s25.8-60.5 8.3-113.1c-6.4-19.3-15.7-39.8-27.7-60.6zm0-30.6c11.9-20.8 21.2-41.2 27.7-60.6C470.8 127.6 466.1 88.1 445 67s-60.5-25.8-113.1-8.3c-19.3 6.4-39.8 15.7-60.6 27.7c28.7 18.8 57.5 42.1 84.9 69.5s50.7 56.2 69.5 84.9zM240.7 86.4c-20.8-11.9-41.2-21.2-60.6-27.7C127.6 41.2 88.1 45.9 67 67s-25.8 60.5-8.3 113.1c6.4 19.3 15.7 39.8 27.7 60.6c18.8-28.7 42.1-57.5 69.5-84.9s56.2-50.7 84.9-69.5zM201.4 256l11.3-11.3 32-32L256 201.4l11.3 11.3 32 32L310.6 256l-11.3 11.3-32 32L256 310.6l-11.3-11.3-32-32L201.4 256zm65.9 20.7l9.4-9.4L288 256l-11.3-11.3-9.4-9.4L256 224l-11.3 11.3-9.4 9.4L224 256l11.3 11.3 9.4 9.4L256 288l11.3-11.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faAtomSimple = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;